import { useContext } from 'react'
import { GridBlockContext } from '../providers'

export const useGridBlock = () => {
  return useContext(GridBlockContext)
}
